/**
 * @param { Promise } promise
 * @return { Promise }
 */
export function to<T = any>(promise: Promise<T>): Promise<[null, string] | [T, null]> {
  return promise
    .then<[T, null]>((data: T) => [data, null])
    .catch<[null, string]>((err) => {
      return [null, err.message.toString() || "服务器错误"];
    });
}
